import { createSlice } from "@reduxjs/toolkit";
import { institution_list } from "../../../types/core_ibass";

export const pendingInstitutions = createSlice({
  name: "pending_institutions",
  initialState: {
    value: {
      status: false,
      pagination: [] as {
        pagination_data: {
          current_page: number;
          last_page: number;
          per_page: number;
          total: number;
          from: number;
          to: number;
        };
        data: institution_list;
      }[],
      data: [] as institution_list,
    },
  },
  reducers: {
    update_pending_institutions: (state, action) => {
      state.value.status = true;
      state.value.data = action?.payload?.data;
    },
    add_pending_institutions: (state, action) => {
      state.value.data = [...state.value.data, action?.payload];
    },
    addToPendingPaginationHistory: (state, action) => {
      state.value.pagination = [
        ...state.value.pagination,
        {
          pagination_data: action?.payload?.pagination_data,
          data: action?.payload?.data,
        },
      ];
    },
    remove_pending_institutions: (state, action) => {
      const { id } = action?.payload;
      const currentArray = [...state.value.data];
      const currentIndex = currentArray.findIndex(
        (v: { id: number }) => Number(v.id) === id
      );
      if (currentIndex > -1) {
        currentArray.splice(currentIndex, 1);
        state.value.data = currentArray;
      }
    },
    replace_pending_institutions: (state, action) => {
      const { id } = action?.payload;
      const currentArray = state.value.data;
      const currentIndex = currentArray.findIndex(
        (v: { id: number }) => v.id === id
      );
      currentArray.splice(currentIndex, 1, action?.payload);
      state.value.data = currentArray;
    },
    clear_pending_institutions: (state) => {
      state.value.status = false;
      state.value.data = [];
    },
  },
});

export const {
  update_pending_institutions,
  add_pending_institutions,
  addToPendingPaginationHistory,
  remove_pending_institutions,
  replace_pending_institutions,
  clear_pending_institutions,
} = pendingInstitutions.actions;

export default pendingInstitutions.reducer;
